import { useCustomerPopup } from "../CustomerPopup";
import { Icon } from "../Icon";
import styles from "./index.module.scss";
type CustomerIconProps = {
  children?: React.ReactNode;
  size?: string;
  className?: string;
};

export const CustomerIcon = (props: CustomerIconProps) => {
  const [customerPopup] = useCustomerPopup();

  return (
    <>
      <div className={props.className || ""} onClick={() => customerPopup()}>
        {props.children ? (
          props.children
        ) : (
          <Icon
            name={"customer-service"}
            size={props.size || "24px"}
            className={styles.icon}
          />
        )}
      </div>
    </>
  );
};
